export const SET_SECTIONS_STYLES = 'SET_SECTIONS_STYLES';
export const UPDATE_SECTIONS_STYLES = 'UPDATE_SECTIONS_STYLES'; // Need To implement
export const UPDATE_SECTION_STYLE = 'UPDATE_SECTION_STYLE'; // Need To implement
export const SET_SECTION_STYLE = 'SET_SECTION_STYLE';
export const SET_IS_LOADING = 'SET_IS_LOADING';
export const ADD_SUBSCRIBED_TOPICS = 'ADD_SUBSCRIBED_TOPICS';
export const ADD_SECTION_PAYLOAD = 'ADD_SECTION_PAYLOAD';
export const SET_EMPLOYEE_TOPIC = 'SET_EMPLOYEE_TOPIC';
export const RESET_EMPLOYEE_TOPIC = 'RESET_EMPLOYEE_TOPIC';
export const UPDATE_TOPIC_DATA = 'UPDATE_TOPIC_DATA';
export const SET_EFFICIENCY_THRESHOLD_LEVELS_AND_SECTIONS_STYLES =
    'SET_EFFICIENCY_THRESHOLD_LEVELS_AND_SECTIONS_STYLES';

const initialState = {
    sections: [],
    section: {},
    isLoading: false,
    dataMap: {},
    subscribedTopics: [],
    employeeTopic: {},
    efficiencyThresholdLevels: [],
};

export const sectionsSelector = (state) => state.sectionStyle.sections;
export const sectionSelector = (state) => state.sectionStyle.section;
export const loadingSelector = (state) => state.sectionStyle.isLoading;
export const topicDataSelector = (state) => state.sectionStyle.dataMap;
export const employeeTopicSelector = (state) =>
    state.sectionStyle.employeeTopic;
export const subscribedTopicsSelector = (state) =>
    state.sectionStyle.subscribedTopics;

export const sectionSelectorState = (state) => ({
    section: state.sectionStyle.section,
    sections: state.sectionStyle.sections,
    isLoading: state.sectionStyle.isLoading,
    efficiencyThresholdLevels: state.sectionStyle.efficiencyThresholdLevels,
});

export const efficiencyThresholdLevelsSelector = (state) =>
    state.sectionStyle.efficiencyThresholdLevels;

export const setSectionsStyles = (sections) => ({
    type: SET_SECTIONS_STYLES,
    payload: sections,
});
export const setSectionStyle = (section) => ({
    type: SET_SECTION_STYLE,
    payload: section,
});
export const setLoadingStyle = (loading) => ({
    type: SET_IS_LOADING,
    payload: loading,
});
export const addSubscribedTopics = (topics) => ({
    type: ADD_SUBSCRIBED_TOPICS,
    payload: topics,
});
export const addSectionStylePayload = (payload) => ({
    type: ADD_SECTION_PAYLOAD,
    payload: payload,
});
export const setEmployeeTopicPayload = (payload) => ({
    type: SET_EMPLOYEE_TOPIC,
    payload: payload,
});
export const resetEmployeeTopicPayload = () => ({
    type: RESET_EMPLOYEE_TOPIC,
});
export const updateTopicData = (topicData) => ({
    type: UPDATE_TOPIC_DATA,
    payload: topicData,
});

export const setEfficiencyThresholdLevelsAndSectionsStyles = (payload) => ({
    type: SET_EFFICIENCY_THRESHOLD_LEVELS_AND_SECTIONS_STYLES,
    payload,
});

export const SectionStyleReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_SECTIONS_STYLES: {
            return { ...state, sections: action.payload };
        }
        case SET_SECTION_STYLE: {
            return { ...state, section: action.payload };
        }
        case SET_IS_LOADING: {
            return { ...state, isLoading: action.payload };
        }
        case ADD_SUBSCRIBED_TOPICS:
            return {
                ...state,
                subscribedTopics: [
                    ...new Set([...state.subscribedTopics, ...action.payload]),
                ],
            };
        case ADD_SECTION_PAYLOAD: {
            return {
                ...state,
                section: { name: state.section?.name || '', ...action.payload },
            };
        }
        case SET_EMPLOYEE_TOPIC: {
            const { topic, machine } = action.payload;
            return {
                ...state,
                employeeTopic: {
                    ...state.employeeTopic,
                    [machine]: topic,
                },
            };
        }
        case RESET_EMPLOYEE_TOPIC: {
            return {
                ...state,
                employeeTopic: {},
            };
        }
        case UPDATE_TOPIC_DATA: {
            const { topic, payload } = action.payload;
            return {
                ...state,
                dataMap: {
                    ...state.dataMap,
                    [topic]: { ...state.dataMap[topic], ...payload },
                },
            };
        }
        case SET_EFFICIENCY_THRESHOLD_LEVELS_AND_SECTIONS_STYLES: {
            return {
                ...state,
                efficiencyThresholdLevels:
                    action.payload.efficiencyThresholdLevels,
                sections: action.payload.sections,
            };
        }
        default:
            return state;
    }
};
